import { render, staticRenderFns } from "./gaia-imgViewer.vue?vue&type=template&id=40884a61&scoped=true&"
import script from "./gaia-imgViewer.vue?vue&type=script&lang=js&"
export * from "./gaia-imgViewer.vue?vue&type=script&lang=js&"
import style1 from "./gaia-imgViewer.vue?vue&type=style&index=1&id=40884a61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40884a61",
  null
  
)

export default component.exports